export enum LocalData {
  AUDIO_PLAYBACK_RATE = 'audioPlaybackRate',
}
